// extracted by mini-css-extract-plugin
var _1 = "vovOS";
var _2 = "MQxwk";
export { _1 as "bodyContainer", _2 as "header" }
